export default {
  computed: {
    isValueTypeValid() {
      window.console.warn('isValueTypeValid not implemented');
    },
    defaultValue() {
      window.console.warn('defaultValue not implemented');
    }
  },
  created() {
    if (!this.isValueTypeValid) {
      const isEmpty = true
      this.$emit('input', this.defaultValue)
      this.$emit('change', isEmpty)
    }
  },
  methods: {
    preEmitHook() {

    },
    emitInput(e) {
      this.preEmitHook(e)
      const valueToSend = this.valueToSendFromEvent(e)
      this.$emit('input', valueToSend)
      this.$emit('change', this.valueIsEmpty(valueToSend))
    },
    // eslint-disable-next-line no-unused-vars
    valueToSendFromEvent(e) {

    },
    valueIsEmpty(value) {
      return value === this.defaultValue
    }
  }
}
